import { useAppSelector } from '@frontend/common';
import { TransactionTypeConstraintData, isTransactionTypeConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { TransactionTypeConstraintDataInputProps } from './transaction-type-constraint-data-input.component';

interface ViewProps {
    formValues: TransactionTypeConstraintData;
}

const useTransactionTypeConstraintDataInput = (props: TransactionTypeConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isTransactionTypeConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { type: null } }));
        }
    }, []);

    return {
        formValues
    };
};

export default useTransactionTypeConstraintDataInput;
